import { WorkflowStepType } from '@bandido/shared/constants';

export const handleDragStart = (event: React.DragEvent<HTMLDivElement>, type: WorkflowStepType): void => {
  event.dataTransfer.setData('application/reactflow', type);
  event.dataTransfer.effectAllowed = 'move';
};
